module.exports = __webpack_public_path__ + "img/ribbon.db4b37d0.png";